var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0013 31.8337C24.7458 31.8337 31.8346 24.7448 31.8346 16.0003C31.8346 7.25582 24.7458 0.166992 16.0013 0.166992C7.25679 0.166992 0.167969 7.25582 0.167969 16.0003C0.167969 24.7448 7.25679 31.8337 16.0013 31.8337ZM24.8027 12.0424C25.2402 11.5538 25.1987 10.8031 24.7101 10.3656C24.2214 9.92814 23.4707 9.96961 23.0332 10.4582L17.6987 16.4166C16.6178 17.6239 15.8898 18.4328 15.2675 18.9559C14.6746 19.4542 14.3263 19.5628 14.0221 19.5628C13.7179 19.5628 13.3697 19.4542 12.7768 18.9559C12.1544 18.4328 11.4265 17.6239 10.3455 16.4166L8.96936 14.8795C8.5319 14.3908 7.78116 14.3494 7.29254 14.7868C6.80392 15.2243 6.76245 15.975 7.19991 16.4637L8.63489 18.0665C9.64165 19.191 10.4814 20.129 11.2487 20.774C12.0604 21.4562 12.9359 21.9378 14.0221 21.9378C15.1084 21.9378 15.9839 21.4562 16.7956 20.774C17.5629 20.129 18.4026 19.191 19.4094 18.0665L24.8027 12.0424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickicon);
export default __webpack_public_path__ + "static/media/tickicon.7dd73bcc237332b66359d7f10279cec2.svg";
export { ForwardRef as ReactComponent };